<div class="card flex justify-center">
    <!-- ✅ Correctly Mapping Toast Positions to Keys -->
    <p-toast position="top-left" key="tl"></p-toast>
    <p-toast position="top-center" key="tc"></p-toast>
    <p-toast position="top-right" key="tr"></p-toast>
    <p-toast position="bottom-left" key="bl"></p-toast>
    <p-toast position="bottom-center" key="bc"></p-toast>
    <p-toast position="bottom-right" key="br"></p-toast>

   
</div>
